import loadImage from "image-promise";
import { debug as d } from "debug";
import { CmsCarousel, CmsDevelopPage, CmsResource } from "./cms-type-definitions";

const debug = d("cs.CmsImagePreloader");

export default class CmsImagePreloader {
  public async preloadImagesForPage(
    promiseOfPage: Promise<CmsDevelopPage | CmsResource>,
  ): Promise<CmsDevelopPage | CmsResource> {
    debug("preloadImagesForPage");
    return this.preloadImages(promiseOfPage, (page) => {
      return page.data.body
        .filter((bodyItem) => bodyItem.primary && (bodyItem.primary as any).content)
        .map((bodyItem) =>
          (bodyItem.primary as any).content
            .filter((item) => item.type === "image")
            .map((item) => item.url),
        );
    });
  }

  public async preloadImagesForCarousel(
    promiseOfCarousel: Promise<CmsCarousel>,
  ): Promise<CmsCarousel> {
    debug("preloadImagesForCarousel");
    return this.preloadImages(promiseOfCarousel, (carousel) => {
      return carousel.data.body
        .filter((bodyItem) => bodyItem.primary && (bodyItem.primary as any).image)
        .map((bodyItem) => (bodyItem.primary as any).image.url);
    });
  }

  private async preloadImages<T>(
    promiseOfDoc: Promise<T>,
    getImagesFromDoc: (T) => string[],
  ): Promise<T> {
    debug("preloadImages");
    const doc = await promiseOfDoc;
    try {
      debug("Got document");
      const imageUrls = ([] as string[]).concat.apply([], getImagesFromDoc(doc));
      if (imageUrls.length > 0) {
        debug(`Pre-loading ${imageUrls.length} images`, imageUrls);
        await loadImage(imageUrls);
        debug("Finished pre-loading");
      }
    } catch (err) {
      debug("Error pre-loading images", err);
    }
    return doc;
  }
}
